export default __webpack_public_path__ + "static/media/task-management-circle.f3337996.webp";